import { render, staticRenderFns } from "./addSolution.vue?vue&type=template&id=0c1a5e08&scoped=true&"
import script from "./addSolution.vue?vue&type=script&lang=js&"
export * from "./addSolution.vue?vue&type=script&lang=js&"
import style0 from "./addSolution.vue?vue&type=style&index=0&id=0c1a5e08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1a5e08",
  null
  
)

export default component.exports